import { render, staticRenderFns } from "./cookie-text-templates-tab.vue?vue&type=template&id=b7752d54"
import script from "./cookie-text-templates-tab.vue?vue&type=script&lang=js"
export * from "./cookie-text-templates-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports